export default __webpack_public_path__ + "static/media/SourceHanSansCN-Regular.7473df6d.ttf";